export const LABELS_DATE = {
    mothStart: "Початок місяця",
    todayDay: "Поточний день",
    weekStart: "Початок тижня",
    weekEnd: "Кінець тижня",
    dateBetween: "Інтервали дат",
    monthEnd: "Кінець місяця",
    monthPreviousStart: "Початок попереднього місяця",
    monthPreviousEnd: "Кінець попереднього місяця",
    yearDayStart: "Перший день року",
    yearDayEnd: "Останній день року",
    quarterDayStart: "Початок кварталу",
    quarterDayEnd: "Кінець кварталу",
    fixedDate: "Фіксована дата",
    templateDate: "Шаблон",
    date:{
        currentDay:'Поточний день',
        lastDay:'Попередній день',
        currentWeek:'Поточний тиждень',
        currentMoth:'Поточний місяць',
        previousMoth:'Попередній місяць',
        currentQuarter:'Поточний квартал',
        currentYear:'Поточний рік',
        last62Days:'Останні 62 дні',

    }
}